import { GetterTree } from 'vuex';

import { IAppConfigState} from './app-config-types.store';
import { CONFIG_FORM_DATA_TYPES } from '../../common/constants';
import { AgendaUserConfig } from '../../models/agenda/calendar-user-config.model';

export const getters: GetterTree<IAppConfigState, any> = {
   getPropertyConfig: (state) => state.formDataConfigs[CONFIG_FORM_DATA_TYPES.PROPERTY],
   getDemandConfig: (state) => state.formDataConfigs[CONFIG_FORM_DATA_TYPES.DEMAND],
   getPersonConfig: (state) => state.formDataConfigs[CONFIG_FORM_DATA_TYPES.PERSON],
   getAgendaConfig: (state) => state.formDataConfigs[CONFIG_FORM_DATA_TYPES.AGRNDA]
      ? new AgendaUserConfig(state.formDataConfigs[CONFIG_FORM_DATA_TYPES.AGRNDA]) : null,
   // Raw agenda config for reactive watching (doesn't create new object instance)
   getAgendaConfigRaw: (state) => state.formDataConfigs[CONFIG_FORM_DATA_TYPES.AGRNDA] || null,
   getUser3CXConfig: (state) => state.userAppConfigs['Show3CXIncomingCall']
}